export enum FeatureTypeEnum {
  NONE = 0,
  CANADA_CA_IRCC_ROUNDS_OF_INVITATIONS = 1,
  CANADA_CA_IRCC_CHECK_PROCESSING_TIMES = 2,
  ONTARIO_CA_OINP_INVITATIONS = 3,
  MANITOBA_CA_EOI_DRAWS = 4,
  ALBERTA_CA_AAIP_UPDATES = 5,
  COLUMBIA_CA_PNP = 6,
  ALBERTA_CA_AAIP_DRAWS = 7,
  NOTIFICATION_SUPPORT = 50,
  STARTUP = 99,
}
